export default {
    payment_failed_please_contact_admin: 'Ihre Zahlung konnte nicht verarbeitet werden. Bitte kontaktieren Sie den Support.',
    login: "Einloggen",
    forgot_password: "Passwort vergessen?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "Es gibt keine weiteren Bilder zur Moderation. Komm später wieder vorbei. Danke für deine Hilfe 😘",
    invalid_token_message: 'Aus Sicherheitsgründen ist Ihr Zugriffstoken abgelaufen.\n \
    Bitte fordern Sie ein neues Token an, um fortzufahren.',
    try_again:'Erneut versuchen',
    timezone: 'Zeitzone',
    timezone_type_automatic: 'Ihre Zeitzone wird automatisch erkannt',
    timezone_type_manually: 'Ihre gewählte Zeitzone wird gesperrt',
    add_links_to_profiles_events_clubs:'Füge Links zu Profilen, Veranstaltungen und Clubs hinzu',
    you_can_add_only_twenty_links: 'Du kannst nur 20 Links hinzufügen',
    enter_your_social_network_handle: 'Gib deinen {social_network}-Benutzernamen ein',
    follow: 'Folgen',
    message: 'Message',
    message_copied: 'Erfolgreich kopiert',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "antworten",
    copy: "kopieren",
    delete_for_all: "für alle löschen",
    now: "JETZT!",
    meet_now:"JETZT treffen!",
    activate_meet_now: "Aktiviere „JETZT!“ und zeige, dass du bereit bist, dich zu treffen.",
    activate_now:"Aktiviere JETZT!",
    deactivate_now:"Deaktiviere JETZT!",
    meet_now_mini_text:"„JETZT!“ bleibt 30 Minuten lang aktiv.",
    finished:"Fertig?",
    over_now:"...JETZT! vorbei",
    headline_or_nickname:"Überschrift oder Spitzname",
    meet_now_upgrade_to_pro:"„JETZT!“ wurde heute schon {0} Mal aktiviert. Hol dir PRO, um „JETZT!“ ohne Limits nochmal zu aktivieren.",
    activate_meet_now_n_times:"Aktiviere „JETZT!“ bis zu {0} Mal pro Tag. PRO-Mitglieder können ohne Einschränkungen aktivieren.",


    email: "Email",
    email_or_username: "Email oder Spitzname",
    photo: "Foto",
    password: "dein Passwort",
    verify_age: 'Alter verifizieren',
    verifying_age: 'Altersüberprüfung',
    verification_success_title: 'Überprüfung abgeschlossen',
    verification_success_desc: 'Dein Alter wurde erfolgreich überprüft.',
    verification_failed_title: 'Überprüfung fehlgeschlagen',
    verification_failed_desc: 'Die Überprüfung wurde nicht bestanden. Du kannst es erneut versuchen, indem du ein anderes Foto auswählst oder hochlädst.',
    verification_limit_title: 'Limit Reached',
    verification_limit_desc: 'You have exceeded the maximum number of age verification attempts. Please try again later.',
    try_again_in: 'Try again in',
    close: 'Close',
    okay: 'Okay',
    start_verification: 'Verifizierung starten',
    choose_photo: 'Foto auswählen',
    age_verification_photo_instruction: 'Bitte laden Sie ein Foto hoch, auf dem Ihr Gesicht gut erkennbar ist. Auf dem Foto darf nur eine Person zu sehen sein.',
    age_verification_description: 'Um Ihr Alter zu verifizieren, folgen Sie bitte den Anweisungen.',
    verify_now: 'Jetzt verifizieren',
    stay_logged_in: "Eingeloggt bleiben?",
    new_to_barebuddy: "Neu bei BUDDY?",
    join_now: "Hier anmelden!",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Passwort wiederfinden",
    reset_password: "Passwort zurücksetzen",
    confirm_password: "Passwort bestätigen",
    recover_now: "Jetzt zurücksetzen",
    create: "Erstellen",
    start: "Start",
    join_modal:{
        become_a_member: "Werde jetzt Mitglied und genieße alle Features.",
        its_quick_and_free: "Es geht schnell und ist kostenlos!",
        already_a_member:"Schon Mitglied?",
    },
    age_modal:{
        'age_check' : 'Altersprüfung',
        'contain_sensitive_material':'Diese Seite könnte sensible Inhalte enthalten.',
        'you_need_eighteen':'Du musst über 18 sein, um fortzufahren.',
    },
    passwords: {
        password: "Passwörter müssen mindestens 6 Zeichen enthalten.",
        reset: "Dein Passwort wurde zurückgesetzt!",
        sent: "Wenn diese E-Mail registriert ist, erhältst Du gleich einen Passwort-Link.",
        token: "Der Link zum Zurücksetzen des Passworts ist ungültig.",
        user: "Wenn diese E-Mail registriert ist, erhältst Du gleich einen Passwort-Link.",
    },
    welcome: {
        what_next: "Was möchtest du als Nächstes tun?",
        nickname: "Spitzname",
        nickname_description: "Vervollständige jetzt dein Profil.",
        discover: "Entdecke BUDDY",
        discover_description: "Chat, Date, Chill, Guide und vieles mehr zu entdecken.",
        pro: "Upgrade auf Pro",
        pro_description: "Unendlicher Spaß mit der Pro-Version."
    },
    invalid_credentials: "Deine Log-in Daten sind nicht korrekt.",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: "Fertig",
        automatic_location: "Automatischer Standort",
        manual_location: "Manueller Standort",
        location_defining: "Standortdefinierend...",
        choose_password: 'Wähle ein Passwort',
        password_looks_good: "Dein Passwort sieht gut aus.",
        pick_nickname: "Schreibe einen Spitznamen für dein Buddy-Profil",
        handle_available: "Buddy-Link ist verfügbar",
        suggestions: 'Vorschläge',
        password_description: "Ihr Passwort muss min. 6 Zeichen lang",
        handle_already_taken : "Dieser Buddy-Link ist bereits vergeben",
        pick_handle: "Dies ist dein Buddy-Link:",
        handle_description : "Dein Buddy-Link hilft anderen, dein Profil zu finden. \n" +
            "Du kannst ihn jetzt oder später in den Einstellungen ändern.",
        nickname: "Spitznamen",
        birthdate: "Geburtstag",
        next: "Weiter",
        enter_email_address: "Deine E-Mail",
        almost_finished: "Fast fertig...",
        upload_photo: "Foto laden",
        add_photo_text: "Füge ein Foto hinzu damit dich\n" +
            "die Buddies sehen können.",
        i_am_ready: "Ich bin fertig",
        skip: "Überspringen",
        back: "Zurück...",
        add_photo: "Foto hinzufügen",
        you_made_it: "Geschafft!",
        accept_terms_privacy_text: "Indem ich auf \"Weiter\" drücke, versichere ich, dass ich 18 Jahre oder älter bin und dass ich die {0} und die {1} akzeptiert habe.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Nutzungsbedingungen",
        privacy_policy: "Datenschutzbestimmungengelesen",
        finish: "Fertig",
        cancel: "Abbrechen",
        upload: "Hochladen",
        welcome_to_bb: "Willkommen bei BUDDY",
        where_are_you_located: "Wo ist dein Standort?",
        use_current_location: "Meinen aktuellen Standort nutzen",
        choose_location_manually: "Meinen Standort selbst wählen",
        lets_go: "Los geht's!",
        human_verification_required: "Bitte fülle die Captcha-Box aus um fortzufahren",
        try_another_photo: "probiere ein anderes Foto...",
        map: "Karte",
        use_gps: "GPS nutzen",
        gps: "GPS",
        type_address: "Hier Adresse eingeben",
    },
    links: {
        about_us: "Über Uns",
        imprint: "Impressum",
        support: "Hilfe",
        terms: "Nutzungsbedingungen",
        community_guidelines: "Community-Richtlinien",
        privacy: "Privatsphäre",
        billing_support: "Zahlungssupport",
    },
    profile_preview: 'Profilvorschau',
    public_gallery: 'Öffentliche Galerie',
    nearby: "In der Nähe",
    recent: "Kürzlich",
    shuffle: "Zufall",
    favorites: "Favoriten",
    favorites_online: "Favoriten online",
    online: "Online",
    send_photo: "Foto schicken",
    send_location: "Ort senden",
    set_location: "Ort setzen",
    type_something: "Schreib etwas...",
    all: "Alle",
    unread: "Ungelesen",
    pos_of_total: "{position} von {total}",
    block_user: "Nutzer blocken",
    report_user: "Nutzer melden",
    user_not_found: 'Benutzer nicht gefunden',
    cancel: "Abbrechen",
    online_now: "Jetzt online",
    away: "Kürzlich online",
    offline: "Nicht da",
    about: "Über mich",
    height: "Größe",
    weight: "Gewicht",
    body: "Körper",
    position: "Position",
    penis: "Schwanz",
    hiv: "Status",
    drugs: "Chems",
    info: "Info",
    stats: "Profil",
    photos: "Fotos",
    settings: "Einstellungen",
    share: "Teilen",

    open_mailbox: 'Mailbox öffnen',

    about_me: "Über mich",
    tags: "Tags",
    access: "Zugang",
    profile_account: "Konto",
    account: "Account",
    logout: "Log out",
    preferences: "Vorlieben",
    show_age: "Alter zeigen",
    yes: "Ja",
    no: "Nein",
    join: "Mitmachen",
    host: "Gastgeber",
    member: "Mitglied",
    language: "Sprache",
    unit_system: "Maßeinheiten",
    metric: "Metrisch",
    imperial: "Imperial",
    website_design: "Website-Design",
    old: "Alt",
    reset: "Zurücksetzen",
    unblock_users: "Nutzer entblocken",
    delete_my_profile: "Mein Profil löschen",
    your_profile_picture: "Mein Profilbild",
    public_pictures: "Öffentliche Bilder",
    can_select_count: "({count} von {total})",
    make_photo_private: "Foto privat machen",
    make_photo_public: "Foto öffentlich stellen",
    set_profile_picture: "Als Profilbild wählen",
    delete_photo: "Foto löschen",
    display_name: "Spitzname",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Ort",
    support: "Hilfe",
    photo_message: "Foto Nachricht",
    distance_away: "{distance} entfernt",
    set_current_location: "Aktuellen Standort benutzen",
    location_message: "Standort Nachricht",
    no_users_around: "Keine Buddies in der Umgebung zu sehen",
    no_more_users_around: "Keine weiteren Buddies in der Nähe",
    to_see_members_become_a_member: 'Um mehr Nutzer zu sehen, werde bitte Mitglied.',
    no_chat_messages: "Chatverlauf ist leer",
    no_more_chat_messages: "Keine weiteren Nachrichten im Chatverlauf",
    message_not_delivered: "nicht zugestellt - antippen um neu zu senden",
    old_password: "Altes Passwort",
    new_password: "Neues Passwort",
    new_password_confirmation: "Passwort wiederholen",
    password_modified: "Dein Passwort wurde erfolgreich geändert",
    wrong_old_password: "Altes Passwort ist nicht korrekt",
    save: "Sichern",
    are_you_sure_delete_profile: "Bist du sicher dass Du Dein Profil löschen willst?",
    all_users_unblocked: "Alle Profile erfolgreich entblockt",
    no_tags: "füge deine Tags hinzu",
    link_copied: "Link kopiert",

    add_tag: "einzelnen Tag eintippen, mit Return bestätigen",
    write_us_help: "Schreib uns für Hilfe, Vorschläge und anderes",
    automatic_location: "Mobiler GPS Standort",
    manual_location: "Standort auf Karte wählen",
    address: "Adresse",
    fail_load_location: "Konnte Deinen Standort nicht erkennen. Möchtest du den Standort manuell wählen?",
    fail_auto_choose_manual_location: "Konnte deinen Standort nicht ermitteln. Bitte wähle deinen Standort manuell.",
    this_is_profile_picture: "Dies ist Dein Profilbild",
    sure_delete_conversation: "Die ganze Konversation löschen?",
    failed_load_user: "Konnte Profil nicht laden",
    please_register: "Bitte anmelden",
    recover_it: "Zurücksetzen", //we talk here about forgotten 'password' on login form
    not_a_member: "Noch kein Mitglied?",
    fail_block_user: "Konnte Profil nicht blockieren",
    user_reported_confirmation: "Danke für deine Meldung. Wir kümmern uns gleich drum",
    register_here: "Hier Anmelden",
    options: {
        body: {
            slim: "Schlank",
            average: "Normal",
            athletic: "Athletisch",
            muscular: "Muskulös",
            stocky: "Kräftig"
        },
        position: {
            top: "aktiv",
            more_top: "eher Aktiv",
            bottom: "passiv",
            more_bottom: "eher Passiv",
            versatile: "beides"
        },
        hiv: {
            positive: "positiv",
            negative: "negativ",
            undetectable: "TasP",
            prep: "PrEP",
            unknown: "unbekannt"
        },
        drugs: {
            yes: "Ja",
            no: "Nein",
            socially: "gelegentlich",
        }
    },
    Sunday: "Sonntag",
    Monday: "Montag",
    Tuesday: "Dienstag",
    Wednesday: "Mittwoch",
    Thursday: "Donnerstag",
    Friday: "Freitag",
    Saturday: "Samstag",
    January: "Januar",
    February: "Februar",
    March: "März",
    April: "April",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "August",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Dezember",
    back: "Zurück",
    report_harassment: "Belästigung",
    report_fake: "Fake",
    report_spam: "Spam",
    report_under_age: "Minderjährig",
    report_other: "Anderes",
    cookies_message: "Cookies helfen uns bei der Bereitstellung unserer Dienste. Durch die Nutzung unserer Dienste erklärst du dich damit einverstanden, dass wir Cookies setzen.",
    learn_more: "Mehr erfahren",
    profile_is_deleted: "Dieses Profil wurde gelöscht",
    crop_photo: "Foto bearbeiten",
    install_pwa_ios_message: "Installiere BUDDY auf dein iPhone: tap <img src=\"/assets/img/iphone-share-btn.jpg\" style=\"height: 26px\" /> and then <strong>Add to Home Screen</strong>: <img style=\"height: 30px\" src=\"/assets/img/add-home-screen-en.png\" />",
    you_are_offline: "Du bist scheinbar offline",
    show_map: "Karte zeigen",
    subscribe_to_newsletter: "Newsletter",
    emails_reminders: "Email Überblick",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    never: "Nie",
    "validation.imageable": "Ungültiges Dateiformat. Bitte lade nur JPG, PNG oder GIF Dateien hoch.",
    user_blocked_confirmation: "Der User wurde blockiert",
    search_users: "Spitzname",
    sure_delete_event: "Dieses Event löschen?",

    home: {
        come_inside: 'Komm rein',
        content_removal : "Inhaltsentfernung",
        bad_boys_society: "Bad Boys Society",
        create_account: "Profil anlegen",
        tagline: "BUDDY",
        fun: "Eine bessere Gay-App bauen",
        login: "E-Mail oder Spitzname",
        password: "Passwort",
        log_in: "Log in",
        remember_me: "Eingeloggt bleiben.",
        forgot_password: "Passwort vergessen?",
        new_here: "Neu hier?",
        sign_up: "Jetzt mitmachen",

        wants: "Zeig deine kinky Seite.",
        wants_desc: "Erfahren oder neugierig, werde Teil der BUDDY Community und lebe deine Kinks. Sende Tapsen und beginne direkt zu chatten. Suche nach Hashtags, um ganz einfach passende Kinksters zu finden.<br><br>Kinky Dates so schnell wie nie.",

        videos: "Videos ansehen und teilen.",
        videos_desc: "Sieh dir massig heisse Videos von Mitgliedern an. Teile Videos aus deiner Gallerie in privaten Chats oder zeig sie öffentlich in deinem Profil.<br><br>Es hat noch nie so viel Spaß gemacht.",

        calendar: "Habt Spaß zusammen.",
        calendar_desc: "Erstelle private Anzeigen in unserem Kalender. Zeige anderen Buddies was du willst und wann du es willst. Lust auf mehr? Organisiere Gruppen und finde neue Kerle.<br><br>Triff Kinksters wie dich.",

        everywhere: "Also, was ist dein Kink?",
        everywhere_desc: "Nutze unsere unzensierte Webseite oder lade die BUDDY App.<br><br>Jetzt anmelden und ausprobieren!",

        generation: "Willkommen im Buddyversum",
        generation_desc: "Wir glauben, dass wir unsere Community am besten unterstützen, indem wir BUDDY allen zugänglich machen. Anders als andere Apps bieten wir die nützlichsten Funktionen komplett gratis. Keine Limits, keine störende Werbung. Wir möchten die beste und größte schwule App für den Kinky- und Fetisch-Lifestyle werden. Mach mit und empfiehl uns weiter.<br><br>Mehr Buddies - mehr Spaß!",

        sign_up_now: "Hier anmelden",

        company: "Company",
        about_us: "Über uns",
        blog: "Blog",
        help: "Hilfe",
        support: "Zahlungsbetreuung",

        legal: "Rechtliches",
        privacy: "Privatsphäre",
        terms: "Nutzungsbedingungen",
        community_guidelines: "Community-Richtlinien",
        usc: "18 U.S.C. 2257",
        imprint: "Impressum",

        languages: "Sprachen",
        follow_us: "Folge uns"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun.",
    },

    company: "Company",
    legal: "Legal",
    community_guidelines: "Community-Richtlinien",
    social_media: "Social Media",
    edit_your_photo: "Du bist wunderschön!",
    complete_profile: "Profil vervollständigen",
    add_more_photos: "Mehr Fotos hinzufügen",
    check_out_guys: "Kerle abchecken",
    members_login: "Mitglieder hier einloggen",
    change_password: "Passwort ändern",
    create_your_event_plus: "Erstelle dein Event. Drücke +",
    create_new_event: "Neues Event erstellen:",
    create_event: "Event erstellen",
    create_your_club_plus: "Erstelle dein Klub. Click +",
    create_new_club: "Neues Klub erstellen:",
    create_club: "Klub erstellen",
    title: "Titel",
    date: "Datum",
    time: "Zeit",
    add_event_details: "Füge Details hinzu:",
    event_description: "Beschreibung",
    club_description: 'Beschreibung',
    club_description_placeholder: 'Worum geht es in Ihrem Club?',
    joined_to_club: "ist beigetreten",
    left_to_club: "ist gegangen",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Tags hinzufügen (optional):",
    select_address: "Adresse wählen",
    location_details: "Location Details (optional)",
    location_example: "(zb  meine Wohnung, Name eines Clubs)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Wähle Bilder für das Event",
    club_choose_photos: 'Wähle Bilder für deinen Club',
    display: "anzeigen:",
    for_censored_app: "für zensierte App",
    visible_only_uncensored_website: "nur auf unzensierter Webseite sichtbar",
    alternative: '',
    hot: "heißes Bild (optional)",
    preview: 'jugendfreies Bild',
    preview_picture: "Vorschaubild",
    submit_event: "Abschicken",
    event_address: "Event Adresse",
    club_address: 'Stadt',
    please_select_preview_picture: "Bitte Vorschaubild wählen",
    set_preview_picture: "Als Vorschaubild nutzen",
    event_successfully_added: "Dein Event wurde erfolgreich hinzugefügt",
    event_successfully_updated: "Ihre Veranstaltung wurde erfolgreich aktualisiert.",
    no_events_around: "Keine Events in der Nähe",
    no_more_event_around: "Keine weiteren Events in der Nähe",
    club_successfully_added: 'Dein Club wurde erfolgreich hinzugefügt',
    no_clubs_around: 'Keine Clubs in der Nähe',
    no_more_club_around: 'Keine weiteren Clubs in der Nähe',
    edit: "Bearbeiten",
    recipient_will_not_see_you: "Der Empfänger sieht nicht dein Profil.",
    public_videos: "Öffentliche Videos",
    send: "Senden",
    event_choose_videos: "Videos für dein Event auswählen",
    delete_video: "Video löschen",
    add_video: "Video hinzufügen",
    videos: "Videos",
    play_video: "Video abspielen",
    video_uploaded_processing: "Dein Video wurde erfolgreich hochgeladen und wird nun verarbeitet. Wir benachrichtigen dich wenn es fertig ist.",
    video_processed: "Dein Video ist jetzt fertig",
    video_message: "Video Nachricht",
    sure_delete_photo: "Dieses Foto löschen?",
    sure_delete_video: "Dieses Video löschen?",
    too_hot: "Zu heiss",
    notifications: "Benachrichtigungen",
    push_notifications: "Push Benachrichtigungen",
    help: "Hilfe",
    profile: "Profil",
    user_blocked: "Du hast diesen Benutzer blockiert oder er hat dich blockiert.",
    open_blocked_users: "Liste der blockierten Benutzer öffnen",
    faq: "FAQ",
    support_chat: "Support chat",
    click_here_tutorials: "Hier gehts zu den Anleitungen",
    send_direct_message: "Sende uns eine direkte Nachricht",
    app: "App",
    security: "Sicherheit",
    notification_sound: "Nachrichtenton",
    deactivate_my_profile: "Deaktiviere mein Profil",
    deactivate_or_delete_my_profile: "Deaktiviere oder Lösche mein Profil",
    customize_sharing_links: "Teilen-Links anpassen",
    delete_all_sharing_links: "Löschen Sie alle Freigabelinks",
    delete_all: "Alles löschen",
    deactivate_account: "Profil deaktivieren",
    taking_break_buddy: "Brauchst du ne Pause von BUDDY?",
    deactivate_text_description: "Deaktivere dein Profil und du bist nicht länger sichtbar auf dem Radar und in der Suche.",
    deactivate: "Deaktivieren",
    delete_profile_text: "Falls du BUDDY komplett verlassen möchtest, {0} um dein Profil zu löschen. Dies kann nicht widerrufen werden und du musst ein neues Profil anlegen wenn du zurück möchtest. Denk dran, jeder braucht nen BUDDY :-)",
    click_here: "hier klicken",
    are_you_sure_deactivate_profile: "Bist du sicher dass du dein Profil deaktivieren möchtest?",
    inactive_profile: "Inaktives Profil",
    account_is_deactivated: 'Dein reizendes BUDDY Profil ist momentan deaktiviert. <br /> Drücke "Aktivieren" um zurückzukehren."',
    activate: "Aktivieren",
    leave: "Verlassen",
    profile_is_deactivated: "Dieses Profil ist momentan deaktiviert",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Deine Medieneinstellungen sind eingestellt dich vor sensiblem Material zu warnen. <br /><br />Um es anzuzeigen musst du eine Auswahl in den Sicherheitseinstellungen ändern",
    change_settings: "Einstellungen ändern",
    show_more: "Mehr anzeigen ...",
    display_sensitive_events: "APP: Sensible Ereignisse",
    display_sensitive_media: "APP: Sensible Medien",
    display_sensitive_media_web: "Web: Sensible Medien",
    tiles: "Kacheln",
    list: "Liste",
    filter: "Filter",
    pics: "Bilder",
    age: "Alter",
    new: "Neu",
    ok: "OK",
    taps: "Tapse",
    visitors: "Besucher",
    visited: "Besucht",
    no_visitors: "Noch keine Besucher",
    no_more_visitors: "keine weiteren Besucher",
    no_visited: "Noch keine Besuche",
    no_more_visited: "keine weitern Besuche",
    no_taps: "Keine Tapse",
    no_more_taps: "Keine weiteren Tapses",

    discreet_mode: "Unsichtbar",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Profil vollständig verbergen",
    hide_profile_completely_tip: "(nur wenn Unsichtbar aktiviert ist)",
    upgrade_to_pro: "Upgraden auf PRO",
    upgrade_to: "Upgraden auf",
    upgrade_now: "Hol' dir PRO",
    upgrade: "Upgrade",
    click_here_to_upgrade: "Hier klicken auf upgraden",
    click_here_to_cancel: "Hier klicken auf abbrechen",
    pro: "PRO",
    cancel_pro: "PRO Kündigen",
    thank_you_for_being_a_pro: "Danke für dein Buddy PRO Upgrade",
    successful_pro_upgrade: "Du bist jetzt ein PRO Buddy!",
    failed_pro_upgrade: "Oh, da ist etwas schiefgelaufen",
    we_hope_you_enjoyed_pro: "Wir hoffen dir hat Buddy PRO gefallen",

    delete_this_message: "Nachricht löschen?",
    delete: "Löschen",
    removed: "entfernt",

    pro_slides_1_title: "Unsichtbar",
    pro_slides_1_description: "mit Masken Modus",
    pro_slides_2_title: "Lesebestätigung",
    pro_slides_2_description: "und Nachrichten nach<br>Absenden entfernen",
    pro_slides_3_title: "Mehr Filter",
    pro_slides_4_title: "Unbegrenzt",
    pro_slides_4_description: "Favoriten, Blocken, Besucher,<br>Profilbilder & Videos",
    pro_slides_5_title: "Mehr Spaß",
    pro_slides_5_description: "alle Videos und Bilder anschauen",

    notifications_button: 'Aktivieren',
    splash_notifications_title: 'Bleib auf dem Laufenden',
    splash_notifications_description: 'Bitte aktiviere Benachrichtigungen, damit du Nachrichten und Hinweise von deinen Buddys erhältst.',

    splash_blocks_title: "Blockieren ohne Limit",
    splash_blocks_description: "Jetzt mit",
    splash_favorites_title: "Endlos Favoriten",
    splash_favorites_description: "speicher' unbegrenzt Profile, mit",
    splash_mask_title: "Unsichtbar",
    splash_mask_description: "mit Unsichtbar. Gönn' dir",
    splash_censored_title: "Mehr sehen",
    splash_censored_description: "Grenzenloser Spaß. Endlich mit",
    splash_visitors_title: "meine Besucher",
    splash_visitors_description: "alle Besucher auf deinem Profil, jetzt mit",
    splash_filters_title: "Mehr Filter",
    splash_filters_description: "Für noch mehr Filter, hol' dir",
    splash_media_title: "Unbegrenzte Pics & Videos im Profil",
    splash_media_description: "Jetzt mit",
    splash_deletemsg_title: "Nachricht löschen",
    splash_deletemsg_description: "nachdem du sie abgeschickt hast, mit",
    splash_change_settings_title: "Deine Medieneinstellungen sind eingestellt, dich vor sensiblem Material zu warnen.",
    splash_change_settings_description: "Um es anzuzeigen, musst du deine Auswahl in den Sicherheitseinstellungen ändern.",
    splash_events_title: "Mehr Events",
    splash_events_description: "Für mehr Events, hol' dir jetzt",

    pro_upgrade_message_desktop: "Abonnements verlängern sich automatisch sofern nicht 24 Stunden vor Ablauf der aktiven Laufzeit gekündigt wird.<br>Bitte besuche <a href='\http://cs.segpay.com\'>SEGPAYEU.COM</a>, unseren autorisierten Zahlungsanbieter.<br>Abbuchen erscheinen auf deiner Kreditkartenabrechnung als <a href=\"http://cs.segpay.com\">SEGPAYEU.COM*BUDDY</a>.",
    pro_upgrade_message_mobile: "Abonnements verlängern sich automatisch sofern nicht 24 Stunden vor Ablauf der aktiven Laufzeit gekündigt wird.",
    payment_blocked: "Bezahlvorgang wird bearbeitet.",
    you_cant_send_messages_to_this_user: "Du kannst diesem Nutzer keine Nachricht schreiben",

    events: {
        report: {
            title: "Report Event",
            wrong_type: "Falsche Kategorie",
            illegal: "Illegal",
        },
        type: {
            friends: "Friends",
            fun: "Date",
            bang: "Chill",
            chemsfriendly: "chemsfriendly",
            required: "Bitte wähle eine Kategorie",
        },
        date: {
            today: "heute",
            tomorrow: "morgen",
            pick_date: "datum"
        },
        link_my_profile: "Mein Profil verlinken",
        not_found: "Event nicht gefunden",
        report_success: "Danke, dass du das Event gemeldet hast. Wir schauen es uns baldmöglichst an",
        new_event: "Neues Event",
        new_bang: "Neues Bang",
        my_events: "Meine Events",
        publish: "Veröffentlichen",
        select_type: 'Welche Art Veranstaltung willst du hinzufügen?',
        about_guide: "öffentliche Veranstaltungen für alle (Parties, Festivals, Community)",
        about_fun: "finde einen Buddy für private 1:1 activities",
        about_bang: "private Gruppenevents organisieren",
        invitation_only_event: "nur auf Einladung (privates Event)",
        please_add_favourite_buddies_first: "Füge zuerst Favoriten hinzu",
        accept: "Annehmen",
        decline: "Ablehnen",
        invited: "Eingeladen",
        invite: "Einladen",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        hide_club_admin: "Club-Admin ausblenden",
        more_clubs: 'Mehr Clubs',
        report: {
            title: 'Report Club',
            wrong_type: 'Falsche Kategorie',
            illegal: 'Illegal',
        },
        type: {
            discover: 'Entdecken',
            my_clubs: 'Meine Clubs',
            chemsfriendly: 'chemsfriendly',
            required: 'Bitte wähle eine Kategorie',
        },
        date: {
            today: "heute",
            tomorrow: "morgen",
            pick_date: "datum"
        },
        not_found: 'Club nicht gefunden',
        report_success: 'Danke, dass du der Club gemeldet hast. Wir schauen es uns baldmöglichst an',
        new_club: 'Neues Club',
        my_clubs: 'Meine Clubs',
        publish: 'Veröffentlichen',
        invitation_only_club: "nur auf Einladung (privates Club)",
        write_to_support_to_open_club: "Schreibe an den Support, wenn du die Privatsphäre dieses Clubs ändern möchtest",
        please_add_favourite_buddies_first: "Füge zuerst Favoriten hinzu",
        accept: "Annehmen",
        decline: "Ablehnen",
        invited: "Eingeladen",
        invite: "Einladen",
    },

    payment: {
        coming_soon: "Bald auf iOS",
        month: "pro Monat",
        send:"Absenden",
        one_month: "monat",
        three_months: "monate",
        twelve_months: "monate",
        your_promotion_code: "Dein Promo Code",
        please_select_payment_option: "Bitte wähle deine Zahlungsart.",
        use_promo_code: "PROmo Code verwenden",
        credit_card: "Kreditkarte",
        alternative_payments: "Alternative Bezahlmethoden",
        renews_automatically_until_cancelled: "Automatische Verlängerung bis zur Stornierung.",
        active_until: "Your PRO-status is active until",
        one_time: "Einmalig",
        no_need_to_cancel: "(Muss nicht gekündigt werden!)",
        upgrade: {
            one_month: "Upgrade für 1 Monat",
            three_months: "Upgrade für 3 Monate",
            twelve_months: "Upgrade für 12 Monate",
        },
        upgrade_paypal: {
            one_month: "PayPal für 1 Monat",
            three_months: "PayPal für 3 Monate",
            twelve_months: "PayPal für 12 Monate",
        },
        thank_you: "Danke!",
        return_to_buddy: "Zurück zu BUDDY",
        paypal: {
            message: "<p>Bitte gib deine PayPal-E-Mail-Adresse ein.</p><br /><p>Wir werden dir einen PayPal-Link an diese Adresse senden.</p><br /> <p>Nachdem wir die Zahlung erhalten haben, <br/> werden wir dein Buddy-Profil aktualisieren.</p>",
            successMessage: "<p>Wir haben deine Upgrade-Anfrage erhalten.</p><br /><p>Wir senden dir in Kürze einen Paypal-Link.</p><br /><p>Nachdem wir die Zahlung erhalten haben, <br /> bitte erlaube uns etwas Zeit, um <br /> dein Upgrade durchzuführen. <br /> Wir machen es per Hand! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Alle Filter freischalten",
            be_invsble: "Unsichtbar sein",
            see_all_who_viewed_me: "Alle anzeigen, die mich angesehen haben",
            remove_messages: "Nachrichten löschen",
            make_notes_on_profile: "Notizen zu Profilen machen",
            unlimited_favorites: "Unbegrenzte Favoriten",
            view_hot_medias: "XXX Medien in der App anzeigen",
            see_if_your_message_has_been_read: "Sehen, ob deine Nachricht gelesen wurde",
            see_wh_marked_you_favorite: "Sehen, wer dich als Favorit markiert hat",
            hide_profile_visits: "Profilbesuche verbergen"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: "Videodauer soll mehr als 1 Sekunde sein",
            highDuration: "Videodauer soll weniger als 15 Minuten sein",
        },
    },

    rush: {
        running_for_x_days: "Läuft seit {days} Tag(en)",
        stars_and_strips_upgrade: "Stars & Strips. Jetzt mit",
        announce: "<span>Hi Buddies,</span><span>die Buddybuilder haben sich was Neues für euch einfallen lassen.</span><span>{0} sind kleine Apps die nützlich sind oder einfach Spaß machen.</span><span>Viel Spaß damit & bleibt neugierig!</span>",
        how_to: {
            title: "RUSH - So geht's.",
            create: "Erstelle Deinen Strip",
            name: "Gib Deinem Strip einen Namen",
            media: "Foto auswählen oder Text schreiben",
            publish: "Veröffentliche Deinen Strip/neue Inhalte",
        },
        welcome: {
            title: "Willkommen bei RUSH",
            story: {
                title: "Deine eigene Story.",
                description: "Lade Fotos in deinen Strip und zeig sie allen Buddys.",
            },
            post: {
                title: "Poste jeden Tag.",
                description: "Verlängere den \"Rush\" und hol dir mehr Applaus.",
            },
            applause: {
                title: "Mehr Applaus?!",
                description: "Bedeutet größeres Vorschaubild. Heißt mehr Buddyviews!",
            },
            attention: {
                title: "Vorsicht!",
                description: "Kommt kein Bild in 24h dazu, verschwindet dein Strip. Der 'Rush' ist vorbei.",
            },
        },
    },
    sure_unblock_user: "Dieses Profil entblocken?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "Es gibt was neues im Buddyversum. Ab sofort findet ihr im Kalender unter der Rubrik »Guide« Parties und Veranstaltungen in eurer Nähe.",
    party_on_text2: "Nach zwei Jahren Pause ist es Zeit, wieder rauszugehen und Spass zu haben. Lasst uns gemeinsam Veranstalter unterstützen, damit die Parties wieder rocken.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Möchten Sie wirklich alle Freigabelinks löschen?",
    all_links_will_be_deactivated: "Alle Links werden deaktiviert.",
    all_sharing_links_deleted_successfully: "Alle Freigabelinks wurden erfolgreich gelöscht",
    this_is_your_sharing_code: "Dies ist dein Link zum Teilen (Klicken zum Kopieren)",
    share_your_selected_videos: "Teile deine ausgewählten Videos mit<br>Leuten, die noch nicht bei Buddy sind.",
    send_via_whatsapp: "Teilen über Whatsapp",
    tap_on_the_videos_you_want_to_share: "Tippe auf die Videos, die du teilen willst",
    cancel_share: "Abbrechen",
    share_now: "Jetzt teilen",
    status:"",
    you_need_to_be_a_pro_for_editing:"Sie müssen ein <strong>PRO</strong> für die Bearbeitung sein",
    expire_at_date:"Ablaufdatum",
    expire_at_time:"Ablaufuhrzeit",
    views_limit:"Aufruflimit",
    you_dont_have_any_links:"Sie haben keine Links",
    link_settings_saved:"Verbindungseinstellungen gespeichert",
    can_not_get_sharing_links:"Freigabelinks können nicht abgerufen werden",
    copied_to_clipboard: "in die Zwischenablage kopiert",
    share_whatsapp_test: "Hier ist der Link zu meinem Video auf buddy.net:",
    share_videos: 'Teilen Sie Videos',
    accept_all: 'Alle akzeptieren',
    no_messages : 'Keine Nachrichten',
    you : 'Du',
    has: 'ist',
    have: 'bist',
    joined: 'beigetreten',
    left: 'gegangen',
    web_push_notifications: 'Web-Push-Benachrichtigungen',
    modal_pro_upgrade_description : 'Nutze dieses und viele weitere Features wenn du dir PRO holst.',
    modal_pro_visit_upgrade_description : 'Versteck diesen Profilbesuch mit PRO',
    note : "Notiz",
    note_textarea_placeholder : "Persönliche Informationen zu diesem Profil hinzufügen...",
    who_marked_me_favorite : "Wer hat mich zum Favoriten erklärt",
    cancel_failed: "Abbrechen fehlgeschlagen, versuchen Sie es noch einmal",
    subscription_canceled: "Abonnement gekündigt",
    confirm_cancel: "Möchten Sie das Abonnement wirklich kündigen?",
    cancel_subscription: "Abonnement kündigen"
}
